import React, { createRef, useEffect } from 'react';
import LoadingBar from 'react-top-loading-bar';

// One bar for the whole app, driven by whichever Suspense fallback is showing.
const barRef = createRef();
let pending = 0;

export function NavigationProgress() {
    return (
        <LoadingBar color="hsl(var(--muted-foreground))" ref={barRef} shadow={true} height={2} />
    );
}

// Use as a Suspense fallback: starts the bar while a lazy page loads and
// completes it once the page is ready.
export function RouteLoadingFallback() {
    useEffect(() => {
        pending += 1;
        if (pending === 1) barRef.current?.continuousStart();
        return () => {
            pending -= 1;
            if (pending === 0) barRef.current?.complete();
        };
    }, []);

    return null;
}
